import React, { ReactNode } from 'react';

// Backdrop layer for the app's Tailwind modal. This is a full-screen element,
// so anything portalled to <body> that must stay clickable while a modal is
// open — MUI pickers, menus, dialogs, snackbars — has to sit above it. MUI's
// popup layers are lifted accordingly in `material-ui/theme.ts`; the coupling
// is enforced by `material-ui/theme.test.ts`. Exported (rather than a `z-[…]`
// class) so that contract has exactly one source.
export const CUSTOM_MODAL_Z_INDEX = 1400;

interface CustomModalProps {
  open: boolean;
  title: string | ReactNode;
  description?: string | ReactNode;
  onClose: () => void;
  children?: ReactNode;
  saveButton: ReactNode;
  closeButton?: ReactNode;
}

const CustomModal = ({
    open,
    title,
    description,
    onClose,
    saveButton,
    closeButton,
    children = null,
}: CustomModalProps) => {
    if (!open) return null;

    return (
        <div
            style={{ zIndex: CUSTOM_MODAL_Z_INDEX }}
            className={'fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 p-4'}
        >
            {/* Cap the panel at the viewport and lay it out as a column so a tall
                form scrolls its body instead of running off-screen, while the
                action buttons stay pinned at the bottom. */}
            <div className={'bg-white rounded-xl shadow-lg w-full max-w-md max-h-[90vh] flex flex-col'}>
                <form
                    className={'flex flex-col min-h-0 flex-1'}
                    onSubmit={(e) => {
                        e.preventDefault();
                    }}
                >
                    <div className={'px-6 py-4 overflow-y-auto flex-1 min-h-0'}>
                        <h2 className={'text-xl font-semibold mb-2'}>{title}</h2>
                        {description && <p className={'text-gray-600 mb-4'}>{description}</p>}
                        {children}
                    </div>
                    <div className={'flex justify-end gap-3 px-6 pb-6 pt-2 shrink-0'}>
                        {closeButton}
                        {saveButton}
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CustomModal;
